import React from "react";

function QtyStepper({ qty, label, onDecrease, onIncrease, disabled = false, increaseDisabled = false }) {
  return (
    <div className="hm-qty">
      <button
        type="button"
        className="hm-qty-btn"
        onClick={onDecrease}
        disabled={disabled || qty <= 0}
        aria-label={"Remove one " + label}
      >
        &#8722;
      </button>
      <span className="hm-qty-n" aria-live="polite" aria-label={label + " quantity"}>
        {qty}
      </span>
      <button
        type="button"
        className="hm-qty-btn"
        onClick={onIncrease}
        disabled={disabled || increaseDisabled}
        aria-label={"Add one " + label}
      >
        +
      </button>
    </div>
  );
}

export default QtyStepper;
